<template>
    <div class="darenInfoContainer clear">
        <div class="contentLeft">
            <div class="part1" v-loading="loadingObj.darenInfo">
                <div class="part1_center">
                    <div class="clear">
                        <div class="imgWrap">
                            <img class="avatar" :src="darenInfo.head_img || crmTalentInfo.avatar_uri || defaultAvatar" alt="">
                            <img class="gender" src="../../assets/woman.png" v-if="darenInfo.gender_desc==='女'">
                            <img class="gender" src="../../assets/man.png" v-if="darenInfo.gender_desc==='男'">
                        </div>
                        <div class="name">
                            <p>
                                <img v-if="authorDrinfo?.month_examples_data?.is_hot == '是'" :src="require(`@/assets/images/火爆.png`)" style="vertical-align: middle;">
                                <img v-if="authorDrinfo?.month_examples_data?.is_must == '是'" :src="require(`@/assets/images/必选.png`)" style="vertical-align: middle;">
                                {{darenInfo.nickname || crmTalentInfo.nickname ||"-"}}
                                <span class="tag-g" v-if="authorDrinfo?.month_examples_data?.discount" >{{authorDrinfo?.month_examples_data?.discount}}折</span>
                                <img src="@/assets/images/schedule/i-calendar.png" class="i-calendar" alt="" v-if="['自孵化号','签约号'].includes($route.query.logings)"
                                    @click="showCalendarDia">
                            </p>
                            <p style="margin-top: 4px;"><i> 平台账号ID(UID): {{darenID.up_id}}</i></p>
                            <p>
                              <i class="isChangwan"  v-if="$route.query.logings">{{$route.query.logings}}</i>
                              <img v-if="$route.query.logings == '签约号' && crmTalentInfo.contract_type=='独家'" src="@/assets/images/djdr.png" style="margin-right: 4px;vertical-align: middle;">
                              <img v-else-if="$route.query.logings == '签约号' && ['非独家，不分商机先后','非独家，优先商机'].includes(crmTalentInfo.contract_type)" src="@/assets/images/fdjdr.png" style="margin-right: 4px;vertical-align: middle;">
                              <img v-else-if="$route.query.logings == '签约号' && crmTalentInfo.contract_type=='弱绑定签约达人'" src="@/assets/images/rbddr.png" style="margin-right: 4px;vertical-align: middle;">
                              <img v-if="magneticLevelIcon" :src="magneticLevelIcon" style="width:60px;margin-right: 4px;vertical-align: bottom;">

                            </p>
                        </div>
                    </div>
                    <div class="icon-group" style="margin-top: 10px;">
                        <img v-if="authorDrinfo?.is_month_examples == '1'" src="@/assets/images/bykl.png">
                        <el-tooltip v-if="authorDrinfo.bl_status == '是'" effect="dark" content="该达人支持保量或历史合作项目中有保量案例，具体条款详见合作明细。" placement="top">
                            <img :src="require(`@/assets/images/支持保量.png`)"  >
                        </el-tooltip>

                        <img v-if="authorDrinfo.is_cooling == 1" :src="require(`@/assets/images/冷却.png`)"  >
                        <img v-if="authorDrinfo.isHistorySign" :src="require(`@/assets/images/历史签约号.png`)"  >
                        <el-tooltip v-if="authorDrinfo.isNewSign" effect="dark" content="1、首次入库，成为签约号的前三个自然月。2、非首次入库，从别的账号状态(例如野生)首次改成签约号的前三个自然月。3、非首次入库，从签约号状态改成别的状态(例如野生)再改回签约号的前三个自然月。" placement="top">
      <img :src="require(`@/assets/images/新签约.png`)"  >
    </el-tooltip>
                        <img v-if="authorDrinfo.is_sup_limit == 1 && authorDrinfo.is_black != 1 && authorDrinfo.is_sup_black != 1" :src="require(`@/assets/images/仅达人本人可合作.png`)" >
                    </div>
                    <ul class="fanInfo">
                        <li>
                            <span>{{darenInfo.fans_num?darenInfo.fans_num:"-"}}</span>
                            <i>粉丝总数</i>
                        </li>
                        <li>
                            <span>{{darenInfo.fans_like_num?darenInfo.fans_like_num:"-"}}</span>
                            <i>粉丝获赞</i>
                        </li>
                        <li>
                            <span>{{darenInfo.video_num?darenInfo.video_num:"-"}}</span>
                            <i>视频总数</i>
                        </li>
                    </ul>
                    <div class="tag1">
                        <span v-for="tag in darenInfo.spark_tagStr" :key="tag">{{tag}}</span>
                    </div>
                    <div class="tag">
                        <span v-for="tag in darenInfo.tags" :key="tag">{{tag}}</span>
                    </div>
                    <div class="info-form-wrap">
                        <div class="form-item ">
                            <div class="label">分成税率%</div>
                            <div class="value">
                                {{authorDrinfo.devidedtax || '-'}}
                            </div>
                        </div>
                        <div class="form-item ">
                            <div class="label">媒体侧建议返点%</div>
                            <div class="value">
                                {{$route.query.logings == '签约号' ? (authorDrinfo.org_devidedrate || '-') : (authorDrinfo.devidedrate || '-')}}
                            </div>
                        </div>
                        <div class="form-item isWhole">
                            <div class="label">分成比例说明</div>
                            <div class="value">
                                {{authorDrinfo.devidedratedesc || '-'}}
                            </div>
                        </div>
                    </div>
                    <div v-if="authorDrinfo.is_black == 1 || authorDrinfo.is_sup_black == 1 || (logings !== '签约号' && authorDrinfo?.history_black_data)" class="alert " @click="authorDrinfo.is_black == 1 || authorDrinfo.is_sup_black == 1 ? null : authorDrinfo?.history_black_data ? hadBlack() : null">
                        <i class="el-icon-warning"></i>
                        <el-tooltip placement="top"  :content="`拉黑理由：${(authorDrinfo.is_black == 1 || authorDrinfo.is_sup_black == 1) ? authorDrinfo?.black_data?.black_reasons : authorDrinfo?.history_black_data ? authorDrinfo?.history_black_data?.black_reasons :'-'}`">
                            <span v-if="authorDrinfo.is_black == 1">达人已被加入畅玩达人黑名单</span>
                            <span v-else-if="authorDrinfo.is_sup_black == 1">达人归属供应商被拉黑</span>
                            <span v-else-if="authorDrinfo?.history_black_data">曾被纳入畅玩达人黑名单</span>
                        </el-tooltip>
                    </div>
                    <div v-if="authorDrinfo?.ban_data?.reason" class="alert ">
                        <i class="el-icon-warning"></i>
                        <el-tooltip placement="top"  :content="'不推荐理由：'+authorDrinfo?.ban_data?.reason || '-'">
                            <span>公司不推荐与该达人合作</span>
                        </el-tooltip>
                    </div>
                    <div class="hr"></div>
                    <div class="block-title">信息概览</div>
                    <div class="info-form-wrap">
                        <template v-for="{label,value,isWhole} in infoForm">
                            <div :class="['form-item',isWhole?'isWhole':'']" :key="label">
                                <div class="label">{{ label }}</div>
                                <div class="value">{{ value }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="hr"></div>
                    <template >
                        <div class="block-title">运营信息</div>
                        <div class="info-form-wrap">
                            <template v-for="{label,value,isWhole} in operationalInfoForm">
                                <div :class="['form-item',isWhole?'isWhole':'']" :key="label">
                                    <div class="label">{{ label }}</div>
                                    <div class="value">{{ value }}</div>
                                </div>
                            </template>
                        </div>
                        <div class="hr"></div>
                    </template>
                    <template v-if="crmTalentInfo.special_saletype">
                        <div class="info-form-wrap" >
                            <div class="block-title">特殊售卖信息</div>
                            <div class="form-item isWhole">
                                <div class="label">特殊售卖类型</div>
                                <div class="value">
                                    <img :src="require(`@/assets/images/${crmTalentInfo.special_saletype}.png`)" style="height: 24.23px;" >
                                </div>
                            </div>
                            <div v-if="crmTalentInfo.special_saledesc" class="form-item isWhole">
                                <div class="label">特殊售卖描述</div>
                                <div class="value">
                                    {{crmTalentInfo.special_saledesc || '-'}}
                                </div>
                            </div>
                        </div>
                        <div class="hr"></div>
                    </template>
                    <div class="block-title">合作相关</div>
                    <div class="info-form-wrap">
                        <div :class="['form-item','isWhole']">
                            <div class="label">主页链接</div>
                            <div class="value">
                                <span class="is-ellipsis">{{ crmTalentInfo.homepage || '-' }}</span>
                                <i class="el-icon-copy-document"  v-clipboard:copy="crmTalentInfo.homepage" v-clipboard:success="onCopy"></i>
                            </div>
                        </div>
                        <template v-for="{label,value,isWhole} in cooperationInfo">
                            <div :class="['form-item',isWhole?'isWhole':'']" :key="label">
                                <div class="label">{{ label }}</div>
                                <div class="value">{{ value }}</div>
                            </div>
                        </template>
                        <div class="form-item isWhole" v-if="!hide_fields.includes('devidedrate')">
                            <div class="label">UP主联系方式</div>
                            <div class="value linkinfo-wrap">
                                {{contact.phone || "***********"}}
                                <i v-if="contact.phone && contact.phone !== '暂无'" class="el-icon-copy-document"  v-clipboard:copy="`${contact.phone}`" v-clipboard:success="onCopy"></i>
                                <i class="el-icon-view show" v-if="!contact.phone" @click="getContactWay(2)"></i>
                            </div>
                        </div>
                        <div class="form-item isWhole">
                            <div class="label">企微群二维码</div>
                            <div class="value linkinfo-wrap">
                                <img :class="{'img-qr': true, 'img-big': contact.wxQr && contact.isGetQr}" v-if="contact.wxQr"
                                    :src="contact.wxQr" alt="企微群二维码" @click="getContactWay(3)">
                                <template v-else>暂无</template>
                            </div>
                        </div>
                    </div>
                    <a :href="homeUrl" target="_blank" class="go-dr-home-page">查看主页</a>
                </div>



            </div>
            <div class="part2">
                <span class="part2Title">
                    服务报价
                    <el-tooltip v-if="authorDrinfo?.month_examples_data?.is_same_price == '否'" effect="dark" placement="top-start">
                        <template #content>
                            <span>该达人实际接单价格与平台不一致，其他备注说明：{{authorDrinfo?.month_examples_data?.notes}}</span>
                        </template>
                        <i class="el-icon-warning-outline"></i>
                    </el-tooltip>
                </span>
                <div v-for="(item,i) in darenInfo.upper_prices" :key="i">
                    <a href="javascript:void(0);" class="priceItem">
                        <span>{{item.cooperation_type_desc}}</span>
                        <i v-if="item.platform_price">￥{{Number(item.platform_price).toLocaleString()}}</i>
                        <i v-else>按订单议价</i>
                    </a>
                </div>
            </div>
        </div>
        <div  class="contentRight">

            <el-tabs class="fixed-top" v-model="activeName" @tab-click="onTabChange">
                <template v-if="darenInfo.nickname">
                    <el-tab-pane label="近期综合表现" name="近期综合表现" />
                    <el-tab-pane label="稿件表现" name="稿件表现" />
                    <el-tab-pane label="成长表现" name="成长表现" />
                    <el-tab-pane label="圈层触达" name="圈层触达" />
                    <el-tab-pane label="作品案例" name="作品案例" />
                    <!-- <el-tab-pane label="相似UP主" name="相似UP主" /> -->
                </template>
                <el-tab-pane label="合作案例" name="合作案例" />
            </el-tabs>
            <div v-if="darenInfo.nickname">
                <!-- 近期综合表现 -->
                <ExpressionNew :fatherDarenInfo="darenInfo" :supplierList="supplierList" />
                <!-- 稿件表现 -->
                <ContentPerformanceView :fatherDarenInfo="darenInfo" />
                <!-- 成长表现 -->
                <GrowthPerformance :fatherDarenInfo="darenInfo" />
                <!-- 圈层触达 -->
                <UserSummary :fatherDarenInfo="darenInfo" />
                <!-- 作品案例 -->
                <WorksGalleryView :fatherDarenInfo="darenInfo" />
                <!-- 相似up主 -->
                <!-- <SimilarUploaderRecommendation  v-loading="loadingObj.darenInfo" :fatherDarenInfo="darenInfo" /> -->
                <!-- 合作案例 锚点h5-->
                <h5 style="opacity: 0;height: 0;margin:0;">合作案例</h5>
                <Cooperation2  plat="b站" :shortid="shortid" ></Cooperation2>
            </div>
            <div v-else class="wrap" style="padding:0;min-height: 700px;">
                <h5 style="opacity: 0;height: 0;margin:0;">合作案例</h5>
                <Cooperation2  plat="b站" :shortid="shortid" ></Cooperation2>
            </div>

        </div>
        <Calendar :outerDiaVisible.sync="outerDiaVisible" :info="calendarInfo"></Calendar>


    </div>
</template>

<script>
// import Expression from "./Expression/Expression.vue";
// import Example from "./Example/Example.vue";
// import Analysis from "./Analysis/Analysis.vue";
// import Cooperation from "./Cooperation/Cooperation.vue";

import CryptoJS from 'crypto-js';

import ExpressionNew from './components/ExpressionNew.vue';
import ContentPerformanceView from './components/ContentPerformanceView.vue';
import GrowthPerformance from './components/GrowthPerformance.vue';
import UserSummary from './components/UserSummary.vue';
import WorksGalleryView from './components/WorksGalleryView.vue';
// import SimilarUploaderRecommendation from './components/SimilarUploaderRecommendation.vue';
import Cooperation2 from "../daren/Cooperation/Cooperation2.vue";
export default {
    name:"bzhan",
    props:[],
    data(){
        return {
            defaultAvatar: require('@/assets/images/avatar.jpg'),
            //达人基础信息
            darenID:{
                up_id:"-",
                cn_id:"-"
            },
            darenInfo:{},
            openDes:{
               des1:false
            },
            activeName: '近期综合表现',//当前tab
            calendarInfo: {},
            outerDiaVisible: false,
            contact: {
                phone: "",
                wxQr: require("./images/icon_4.png"),
                isGetQr: false,
                loading: false,
            },
            hide_fields: [],
            is_product: false,
            crmTalentInfo: {},
            authorDrinfo: {},
            scrolling: false, //页面是否在滚动中,用于防止观察者在点击tab后滚动动画时还触发
            titleObserver: null, //对右侧h5标题是否进入视窗的观察者对象

            loadingObj: {
                darenInfo: false
            },
            supplierList: []
        }
    },
    components:{
        ExpressionNew,
        ContentPerformanceView,
        GrowthPerformance,
        UserSummary,
        WorksGalleryView,
        // SimilarUploaderRecommendation,
        Cooperation2,
        // 旧布局使用的组件,现在布局变了，用新的替换了
        // Expression,
        // Example,
        // Analysis,
        // Cooperation,
        // 旧的组件.
        Calendar: () => import("@/components/calendar/calendar.vue")
    },
    computed:{
        shortid(){
            return this.$route.query?.up_id || ''
        },
        homeUrl(){
            return `https://space.bilibili.com/${this.$route.query.up_id}`
        },
        magneticLevelIcon(){  //磁力值
          if (this.darenInfo.magnetic_level && this.darenInfo.magnetic_level >= 1 && this.darenInfo.magnetic_level <= 8) {
            return require(`@/pages/bzhan/images/cili/LV${this.darenInfo.magnetic_level}.png`)
          } else {
            return null
          }

        },
        // 签约状态
        signStatus(){
            const today = this.dayjs().format("YYYY-MM-DD")
            const last_contract = this.crmTalentInfo.last_contract
            if (!last_contract) {
                return '-'
            } else if (today>last_contract.due_dt){
                return '已过期'
            } else if (today>=last_contract.sign_dt&&today<= last_contract.due_dt){
                return '已签约'
            } else {
                return '-'
            }
        },
        infoForm(){
            const darenInfo = this.darenInfo
            const authorDrinfo = this.authorDrinfo
            return [
                {
                    label:'地域',
                    value:[darenInfo.region_desc,darenInfo.second_region_desc].filter(item => item).join('-')||'-',
                    isWhole:0
                },
                {
                    label:'MCN',
                    value:darenInfo.mcn_company_name||'-',
                    isWhole:0
                },
                {
                    label:'职业',
                    value:darenInfo.occupation_tag?.join(',')||'-',
                    isWhole:0
                },
                {
                    label:'人设',
                    value:darenInfo.character_tag?.join(',')||'-',
                    isWhole:0
                },
                {
                    label:'个人介绍',
                    value:darenInfo.signature||'-',
                    isWhole:1
                },
                {
                    label:'近期合作行业',
                    value:darenInfo.category_names?.join(',')||'-',
                    isWhole:1
                },
                {
                    label:'推荐理由',
                    value: authorDrinfo?.month_examples_data?.reason || '-',
                    isWhole:1
                },
            ]
        },
        operationalInfoForm(){
            // const darenInfo = this.darenInfo
            const authorDrinfo = this.authorDrinfo
            return [
                {
                    show: true,
                    label:'入库运营',
                    value: authorDrinfo.signoperation ||'-',
                    isWhole:1
                },
                {
                    show: this.logings == '签约号',
                    label:'mcn商务运营',
                    value: authorDrinfo.mcn_buname ||'-',
                    isWhole:1
                },
                {
                    show: this.logings == '签约号',
                    label:'mcn签约经纪人',
                    value: authorDrinfo.mcn_uname ||'-',
                    isWhole:1
                },
            ].filter(item => item.show)
        },
        cooperationInfo(){
            // const darenInfo = this.darenInfo
            const crmTalentInfo = this.crmTalentInfo
            const authorDrinfo = this.authorDrinfo
            return [
                {
                    label: '签约状态',
                    value: crmTalentInfo.last_contract ? this.signStatus : '-',
                    isWhole:1
                },
                {
                    label: '合作有效期',
                    value: crmTalentInfo.last_contract ?
                           crmTalentInfo.last_contract.sign_dt + '至' + crmTalentInfo.last_contract.due_dt : '-',
                    isWhole:1
                },
                {
                    show: crmTalentInfo.star,
                    label: '花火机构',
                    value: crmTalentInfo.star || '-',
                    isWhole:1
                },
                {
                    show: this.logings == '签约号',
                    label: '签约合同',
                    value: authorDrinfo?.last_contract?.contract_num || '-',
                    isWhole:1
                },
            ].filter(item => 'show' in item ? item.show : true)
        },
        logings() {
            const logings = this.$route.query.logings || ''
            if (['合作号', '野生'].includes(logings)) {
                return '合作号/野生'
            } else {
                return logings
            }
        },
    },
    watch: {
        activeName: {
            handler() {
                if(this.activeName === "合作案例") {
                    // 合作案例埋点
                    let logParams = {
                        type: 5,
                        plat: 3,
                        shortid: this.darenID.up_id,
                        starid: ""
                    }
                    this.$api.setUseLog(logParams)
                }
            }
        }
    },
    beforeRouteEnter (to, from, next) {
      let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
      let name=window.sessionStorage.getItem('name')
      window.sessionStorage.clear()
      window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
      window.sessionStorage.setItem('name',name)
      next()
    },
    created(){
        this.darenID.up_id=this.$route.query.up_id,
        this.darenID.cn_id=this.$route.query.cn_id
        // b站还没改版 所以先用抖音的权限
        this.hide_fields = JSON.parse(localStorage.getItem("dy_hide_fields")) || []
        this.is_product = localStorage.getItem("gx_is_product") ? JSON.parse(localStorage.getItem('gx_is_product')) : ""

        this.loadingObj.darenInfo = true
        this.$api.getBZhanData.getBlPortrait(`?upper_mid=${this.darenID.up_id}&mcn_id=${this.darenID.cn_id}`).then((res) => {
            if(res.data.code!==0){
                this.$message.warning(res.data.error)
                this.activeName = '合作案例'
                return
            }
            this.initGetBlPortrait(res.data.data)
        }).finally(()=>{
            this.loadingObj.darenInfo = false
        })
        this.calendarInfo = {
            plat: "B站",
            shortid: this.darenID.up_id,
            starid: ""
        }
        this.getCrmTalentInfo()


    },
    mounted(){
        setTimeout(() => {
            this.titleObserver = this.titleObserverInit()
        }, 1000);

    },
    beforeDestroy() {
        this.titleObserver?.disconnect?.()
    },
    methods:{
        hadBlack(){
            let blackType = '曾被纳入畅玩达人黑名单'
            this.$alert(`
            <div style="display: flex; align-items: center">
                <i class="el-icon-warning" style="font-size: 50px; color: #FF6F28;margin-right: 10px"></i>
                <div>
                    <p>${blackType}，拉黑理由：</p>
                    <p style="font-weight: 600; color: #FF6F28;">${this.authorDrinfo?.history_black_data?.black_reasons || '-'}</p>
                </div>
            </div>
            `, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '我知道了'
            });
      },
        pinkTagsFormat(arr = []) {
            const map = {
                // "cosmetics_other_cooperate": "美妆行业合作", //（有这个标签的会在美妆行业里）
                // "car_cooperate": "汽车行业合作", // （有这个标签的会在汽车行业里）
                // "digit_other_cooperate": "数码行业合作", //（有这个标签的会在数码行业里）
                // "digit_coo_frequent": "",
                // "digit_cooperate": "",
                // "game_other_cooperate": "游戏行业合作", //（有这个标签的会在游戏行业里）
                // "car_other_cooperate": "",
                // "play_stable": "",
                "coo_multi_industry": "多行业合作经验",
                "coo_frequent": "合作经验丰富",
                "cooperate": "有合作经验",
                "grow_fast": "成长快",
                "hot_frequent": "多次热门",
                "hot": "上过热门",
                "must_week_3m": "每周必看",
            }
            const tagKeys = [
                'must_week_3m',
                'grow_fast',
                [
                    'hot_frequent', 'hot',  //优先级从高到低
                ],
                [
                    'coo_multi_industry', 'coo_frequent', 'cooperate'
                ]
            ]
            const tags = []
            for (const currentKey of tagKeys) {
                let key
                if (Array.isArray(currentKey)) {
                    for (const item of currentKey) {
                        if (arr.includes(item)) {
                            key = item
                            break
                        }
                    }
                } else if (arr.includes(currentKey)) {
                    key = currentKey
                }
                if (key) {
                    tags.push(map[key])
                }
            }
            return tags
        },
        initGetBlPortrait(val){
            val.fans_num=val.fans_num>10000?((val.fans_num/10000).toFixed(1))+"万":val.fans_num
            val.fans_like_num=val.fans_like_num>10000?((val.fans_like_num/10000).toFixed(1))+"万":val.fans_like_num
            val.video_num=val.video_num>10000?((val.video_num/10000).toFixed(1))+"万":val.video_num
            val.spark_tagStr = this.pinkTagsFormat(val?.spark_tag || [])
            this.darenInfo=val

        },
        openDesMethord(des){
            if(des === 'des1'){
                this.openDes.des1=!this.openDes.des1
            }
        },
        showCalendarDia() {
            this.outerDiaVisible = true
        },
        async getCrmTalentInfo() {
            // this.$axios.get('/api.php?a=talentInLib&m=gx', {
            //     params: {
            //         platid: 3,
            //         shortids: this.darenID.up_id || '',
            //     },
            //     headers: { showLoading: false }
            // }).then(res => {
            //     if(res.list?.length){
            //         this.crmTalentInfo = res.list[0]
            //     }
            // })

            const res = await this.$axios.get('/api.php?m=index|api|gx&a=talentDetail', {
                params: {
                    starid: this.$route.query.id || '',
                    shortid:this.darenID.up_id || '',
                    plat:3,
                },
                headers: {
                    showLoading: false
                }
            })
            res.special_saletype = res.special_saletype?.split(',')?.filter(item => item !== '促销' && item)?.[0]
            // 3个月前的日期节点
            const newSignDateFlag = this.dayjs().subtract(3, 'month')
            // 历史签约号
            res.isHistorySign = res.logings !== '签约号' && res.has_sign == 1
            // 新签约号，当前是签约号，并且签约时间在3个月内
            res.isNewSign = res.logings == '签约号' && newSignDateFlag.isBefore(res.last_sign_time)
            this.crmTalentInfo = res
            this.authorDrinfo = res

            if (this.is_product && this.logings == '合作号/野生') {
                this.getSupplierData(this.crmTalentInfo.id)
            }

            if(this.authorDrinfo.is_black == 1 || this.authorDrinfo.is_sup_black == 1) {
                let blackType = this.authorDrinfo.is_black == 1 ? '达人已被加入畅玩达人黑名单' : '达人归属供应商被拉黑'
                this.$alert(`
        <div style="display: flex; align-items: center">
                    <i class="el-icon-warning" style="font-size: 50px; color: #FF6F28;margin-right: 10px"></i>
                    <div>
                        <p>${blackType}，拉黑理由：</p>
                        <p style="font-weight: 600; color: #FF6F28;">${this.authorDrinfo?.black_data?.black_reasons || '-'}</p>
                    </div>
                </div>
        `, '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '我知道了'
                });
            }
        },
        getContactWay(type) {
            if(type === 3 && this.contact.isGetQr) return
            this.contact.loading = true
            // plat=(3=观星数据,4=媒体库)
            // type=(2=联系方式,3=群二维码,4=身份证,5=手机号，6=银行卡号)
            let params = {
                mid: this.crmTalentInfo.id, //媒体库id
                sign: CryptoJS.MD5(`${this.crmTalentInfo.id},${localStorage.getItem('uid')}`).toString(), //id和shortidMD5
                type,
                plat:3
            }
            this.$axios.get(`api.php?m=detail|api|gx&a=getContact`, {params, headers: {showLoading: false}}).then(res => {
                if(type === 2) {
                    this.contact.phone = res.contactmode || '暂无'
                }else if(type === 3) {
                    this.contact.wxQr = res.qr_code || ''
                    this.$nextTick(() => {
                        this.contact.isGetQr = true
                    })
                }
            }).finally(() => {
                this.contact.loading = false
            })
        },
        onCopy(){
            this.$message.success('已复制到剪切板')
        },
        onTabChange(obj){
            let { name } = obj
            const nodeList = document.querySelectorAll('.contentRight h5')
            const node = Array.from(nodeList).find(node => node.innerText == name)
            if (node) {
                this.scrolling = true
                scrollTo({ top:node.offsetTop -100,  behavior:'smooth' })
                setTimeout(() => {
                    this.scrolling = false
                }, 1000);
            }
        },
        titleObserverInit(){
            const observerOptions = {
                threshold: 1,  //h5标题需要完全展示才算
            };
            const observerCallback = (entries, observer) => {
                for (const entry of entries) {
                    if (!this.scrolling && entry.isIntersecting) {
                        // console.log(entry.target.innerText);
                        this.activeName = entry.target.innerText; // 设置当前激活的 tab 名称
                        return
                    }
                }
            };
            const nodeList = document.querySelectorAll('.contentRight h5');
            const observer = new IntersectionObserver(observerCallback, observerOptions);
            Array.from(nodeList).forEach((node) => {
                observer.observe(node);
            });
            return observer
        },
        async getSupplierData(id) {
            this.$axios.get('/api.php?m=index|api|gx&a=getProductlogings', { params:{ mid: id }}).then(resdata => {
                this.supplierList = resdata
            })
        },
    }
}
</script>

<style scoped lang="less">
 .alert {
        margin: 10px 0;
        border-radius: 4px;
        background-color: #e5e6eb;
        font-family: '苹方 常规体', '苹方', sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #4E5969;
        box-sizing: border-box;
        font-size: 14px;
        height: 28px;
        display: flex;
        align-items: center;

        i {
            font-size: 16px;
            vertical-align: middle;
            margin: 0 10px;
            color: #a9aeb8;
        }
    }
    .price2 {
        margin-bottom: 20px;
        font-size: 18px;
        font-family: OPPOSans;
        font-weight: 800;
        color: #ff5c00;
    }
    .industry{
        padding-top: 10px;
    }
    .industry span{
        margin-top: 16px;
        color: #333;
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;
    }
    .industry p{
        margin-top: 8px;
        color: #999;
        font-size: 12px;
        line-height: 18px;
    }
    .industry p i{
        display: inline-block;
        margin-right: 10px;
    }

    .darenInfoContainer{
        min-width: 1200px;
        // margin: 16px auto 40px;
        display: flex;
        justify-content: center;
        margin-top: 14px;

    }
    .contentLeft{
        flex: 0 0 320px;
        margin-right: 14px;
        // float: left;
        // width: 320px;
        height: 100px;
        background: #fff;
        border-radius: 6px;
    }

    .contentLeft .part1{
        position: relative;
        width: 100%;
        padding-bottom: 24px;
        background: #FFFFFF;
        border-radius: 6px;
    }
    .contentLeft .part1 .part1_top{
        width: 100%;
        height: 57px;
        line-height: 57px;
        padding-left: 24px;
        border-bottom: 1px solid #E8E8E8;
        box-sizing: border-box;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        text-align: left;
    }
    .contentLeft .part1 .part1_top span{
        float: left;
    }
    .contentLeft .part1_top i{
        float: left;
        width: 24px;
        height: 24px;
        margin-top: 16px;
        margin-left: 12px;
        background: #F5F5F5 url("./images/icon_4.png") no-repeat center;
        cursor: pointer;
    }
    .contentLeft .part1_top i:hover{
        background-image: url("./images/icon_5.png");
        background-color: #FFF2EB;
    }
    .contentLeft .part1_top i:hover .erweima{
        display: block;
    }


/* topTitle tab公共样式 start*/

  .darenInfoContainer /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FF5C00;
    background-color: #FFF2EB;
    border-color: #FF5C00;
    box-shadow: -1px 0 0 0 #FF5C00;
  }
  .darenInfoContainer /deep/ .el-radio-button__inner:hover{
    color: #333;
  }
  .darenInfoContainer /deep/ .el-radio-button__inner{
    padding: 10px 16px;
  }
  .darenInfoContainer /deep/ .el-radio-button:first-child .el-radio-button__inner{
    border-radius: 2px 0 0 2px;
  }
  .darenInfoContainer /deep/ .el-radio-button:last-child .el-radio-button__inner{
    border-radius: 0
  }

  /* topTitle tab公共样式 end*/
    .part1_top .erweima{
        display: none;
        position: absolute;
        top: 15px;
        left: 170px;
        padding: 20px 0 40px;
        width: 180px;
        box-shadow:0px 0px 5px rgba(0,0,0,.1);
        background: #fff;
        border-radius: 4px;
        text-align: center;
        z-index: 999;
    }
    .part1_top .erweima::before{
        position: absolute;
        top: 8px;
        left: -5px;
        content: "";
        width:0;
        height:0;
        border-width:6px 6px 6px 0;
        border-style:solid;
        border-color:transparent #fff transparent transparent;
        z-index: 1;
    }
    .part1_top .erweima::after{
        position: absolute;
        top: 8px;
        left: -6px;
        content: "";
        width:0;
        height:0;
        border-width:6px 6px 6px 0;
        border-style:solid;
        border-color:transparent rgba(0,0,0,.08) transparent transparent;
        filter: blur(1px);
    }

    .part1_top .erweima img{
        display:inline-block;
        width: 120px;
        height: 120px;
        margin-bottom: -12px;
    }
    .part1_top .erweima p{
        margin: 0;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #999999;
        text-align: center;
    }
    .part1_center{
        padding: 26px 20px 10px;
        box-sizing: border-box;
    }
    .part1_center .industry2{
        position: relative;
        padding-top: 10px;
    }
    .part1_center .industry2 i{
        position: absolute;
        bottom: 4px;
        right: 0;
        padding-left: 40px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #38A1FF;
        cursor: pointer;
        background: linear-gradient(left,rgba(255,255,255,0)4%,rgba(255,255,255,1)60%) ;
    }
    .part1_center .industry2 span{
        margin-top: 16px;
        color: #333;
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;
    }
    .part1_center .industry2 p{
        margin-top: 8px;
        color: #999;
        font-size: 12px;
        line-height: 18px;
    }
    .part1_center .industry2 p.flod{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .part1_center .imgWrap{
        float: left;
        width: 60px;
        // height: 60px;
        margin-right: 12px;

        // overflow: hidden;
        position: relative;
        .gender{
            position: absolute;
            right: 0;
            bottom: 0;
            margin:auto;
            display: block;
            width: 20px;
            height: 20px;
        }
    }
    .part1_center .imgWrap .avatar{
        display: block;
        width: 60px;
        height: 60px;
        border-radius: 50%;
    }
    .part1_center .name{
        float: left;
        width: 208px;
    }
    .part1_center .name .isChangwan{
        display: inline-block;
        // margin-top: 4px;
        // margin-left: 10px;
        /* width: 56px; */
        padding: 0 6px;
        height: 20px;
        line-height: 20px;
        background: #fff2eb;
        color: #ff5c00;
        border-radius: 2px;
        text-align: center;
        &.not-into{
            background: #e4e5ea;
            color: #aaaeb9;
        }
    }
    .part1_center .name p{
        margin: 0;
        // margin-bottom: 4px;
        text-align: left;
    }
    .part1_center .name p img{
        display: inline-block;
        margin-left: 10px;
        &.i-calendar{
            width: 16px;
            height: 16px;
        }
    }
    // .part1_center .name span{
    //     position: relative;
    //     margin-left: 20px;
    //     margin-right: 16px;
    //     font-size: 14px;
    //     font-family: OPPOSans;
    //     font-weight: 500;
    //     color: #333333;
    // }
    // .part1_center .name span::before{
    //     position: absolute;
    //     left: -20px;
    //     content: "";
    //     width: 20px;
    //     height: 20px;
    //     background: url("../../assets/local.png") no-repeat center;
    // }
    .part1_center .name i{
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #999999;
    }
    .part1_center .name i:nth-of-type(2){
        margin-right: 0;
    }
    .part1_center .tag{
        margin-top: 8px;
        text-align: left;
        span{
            display: inline-block;
            margin-right: 12px;
            margin-bottom: 12px;
            padding: 6px 12px;
            background: #F6F6F6;
            border-radius:20px;
            font-size: 14px;
            font-family: OPPOSans;
            font-weight: 400;
            color: #333333;
        }
    }
    .part1_center .tag1{
        margin-top: 8px;
        text-align: left;
        span{
            display: inline-block;
            margin-right: 8px;
            margin-bottom: 8px;
            padding: 4px 9px;
            background:#ffe8f1;
            border-radius: 2px;
            font-size: 12px;
            font-family: OPPOSans;
            font-weight: 400;
            color: #fa79c4;
        }
    }

    //服务报价
    .part2 {
        width: 320px;
        margin-top: 16px;
        padding: 0 20px 20px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .part2 .info{
        margin-top: 0;
    }
    .part2 .part2Title{
        width: 100%;
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
    }
    .part2 .priceItem{
        display: block;
        width: 100%;
        height: 52px;
        margin-bottom: 16px;
        padding: 0 20px;
        background: #FFFFFF;
        border: 1px solid #F0F0F0;
        border-radius: 2px;
        box-sizing: border-box;
    }
    .part2 .priceItem:hover{
        border-color: #FF5C00;
    }
    .part2 .priceItem span{
        float: left;
        line-height: 52px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #999999;
    }
    .part2 .priceItem i{
        float: right;
        line-height: 52px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 800;
        color: #FF5C00;
    }
    .part2 p{
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }
    .part2 .toBroadcast{
        display: block;
        width: 100%;
        height: 34px;
        line-height: 34px;
        background: #FFF2EB;
        border-radius: 2px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 400;
        text-align: center;
        color: #FF5C00;
    }
    .contentRight{
        // float: right;
        width: 1176px;
        /deep/ .el-tabs__header{
          position: sticky;
          top: 0;
          z-index: 10;
        }
    }
    .contentRight /deep/ .el-tabs__active-bar{
        background-color: #FF5C00!important;
    }
    .contentRight /deep/ .el-tabs__item{
        color: #333;
        height: 50px;
        line-height: 50px;
    }
    .contentRight /deep/ .el-tabs__nav-scroll {
        height: 50px;
        padding-left: 24px;
        background: #fff;
        border-radius: 6px;
    }
    .contentRight /deep/ .el-tabs__item.is-active {
        color: #333;
    }
    .contentRight /deep/ .el-tabs__header{
        margin-bottom: 0;
    }
    .contentRight /deep/ .el-tabs__content{
        margin-top: 15px;
    }
    .contentRight /deep/ .el-tabs__nav-wrap::after{
        height: 1px;
        background: #f5f5f5;
    }
    .part1_center .item:nth-child(1){
        margin-top: 14px;
    }
    .part1 .fanInfo{
        display: flex;
        padding-left: 0;
        margin-left: -10px;
        align-items: center;
    }
    .part1 .fanInfo li{
        width: 33%;
    }
    .part1 .fanInfo span{
        display: block;
        font-weight: 600;
        font-size: 16px;
        color: #FF5C00;
        text-align: center;
    }
    .part1 .fanInfo i{
        display: block;
        margin-top: 6px;
        font-size: 12px;
        color: #999999;
        text-align: center;
    }

    // 改版新增样式
    .block-title{
        line-height: 50px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
    }
    .info-form-wrap{
        font-size: 14px;
        // font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        .form-item{
            margin-bottom:12px;
            &.isWhole{
                width: 100%;
            }
            width:50%;
            display: inline-flex;
            line-height: 1.5;
            .label{
                flex:none;
                min-width: 0;
                color:rgb(78, 89, 105);
                margin-right: 8px;
                color: #333;
                font-size: 12px;
                font-weight: 700;
            }
            .value{
                flex:1;
                word-break: break-all;
                overflow-wrap: break-word;
                font-size: 12px;
                // font-family: OPPOSans;
                font-weight: 500;
                display: flex;
                align-items: center;
                .is-ellipsis{
                    display: inline-block;
                    max-width: 200px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

        }
    }
    .linkinfo-wrap{
        i{
            cursor: pointer;
            margin-left: 4px;
            vertical-align: middle;
        }
        .show{
            margin-left: 8px;
            font-family: OPPOSans;
            font-weight: bold;
            color: #38A1FF;
            cursor: pointer;

        }
        .img-qr{
            width: 14px;
            height: 14px;
            vertical-align: text-top;
            cursor: pointer;
            &.img-big{
                width: 100px;
                height: 100px;
            }
        }
    }
    .go-dr-home-page {
        display: block;
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        background-color: #ff6f28;
        border-radius: 4px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 500;
        cursor: pointer;
    }

    .fixed-top{
        height:50px;
        z-index: 10;
        position: sticky;
        top:0;
        border-radius: 6px
    }

    ::v-deep {
        // 覆盖单选按钮 start
        .el-radio-button__inner {
            border: none !important;
        }

        .is-active .el-radio-button__inner {
            box-shadow: none !important;
            background-color: #f2f3f5 !important;
            border-radius: 30px !important;
        }
        // 覆盖单选按钮 end

        // 覆盖下拉框 start
        .vxe-input--inner{
            background-color: #f2f3f5;
            border-color:  #f2f3f5;
        }
        // 覆盖下拉框 end

        .wrap {
            margin: 12px 0;
            padding: 0 30px 20px;
            background: #FFFFFF;
            border-radius: 6px;
            box-sizing: border-box;
        }
        .top {
                width: 100%;
                height: 76px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                h5{
                    font-size: 18px;
                }
            }
        .text1{
            font-size: 14px;
            line-height:2rem;
            margin:unset;
        }
        .high-light{
            color:rgb(255, 111, 40);
            font-weight: 700;
        }
    }

    .i-calendar {
        width: 16px;
        height: 16px;
        margin-left: 5px;
        cursor: pointer;
    }
    .tag-g {
        margin: 0 4px;
        color: #00b42a !important;
        padding: 4px 6px 4px 6px;
        background-color: #e6f8ea;
        border-radius: 4px;
        line-height: 12px;
        font-size: 10px  !important;
        display: inline-block;
    }
    .icon-group {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-flow: row wrap;
    }
</style>
